module.exports = __webpack_public_path__ + "static/media/answer_highlightd.3ef9a2b7.svg";